import React from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';
import { useBoolean } from 'usehooks-ts';
import { formatEther } from 'viem';

import {
  useDepositsOrThrow,
  useTotalRewardsOrThrow,
} from '@web/features/staking/hooks';
import { useCurrentCompletedUser } from '@web/features/user/service';
import { Button } from '@web/ui/components';
import { UnaAmountIcon } from '@web/ui/icons';

import { ClaimModal } from '../../modals/ClaimModal';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing('1000')};
  padding-top: ${({ theme }) => theme.spacing('3000')};
`;

const UnaAmountContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing('0500')};
  align-self: stretch;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 3rem;
  }
`;

const UnaAmount = styled.p`
  color: ${({ theme }) => theme.color.greenFixed};
  font: ${({ theme }) => theme.typography.body.regular};
  font-size: ${({ theme }) => theme.typescale.size['10']};

  text-shadow: 0px 0px 4px ${({ theme }) => theme.color.greenFixed};
`;

const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.color.onGreenFixed};
`;

export const StakingRewards = () => {
  const t = useTranslations();

  const completedUser = useCurrentCompletedUser();

  const {
    value: isClaimModalOpen,
    setTrue: openClaimModal,
    setFalse: closeClaimModal,
  } = useBoolean(false);

  const { tokenIds } = useDepositsOrThrow();
  const rewards = useTotalRewardsOrThrow();

  return (
    <>
      <UnaAmountContainer>
        <UnaAmount>{Number(formatEther(rewards)).toFixed(2)}</UnaAmount>
        <UnaAmountIcon size="2500" />
      </UnaAmountContainer>
      <Container>
        <StyledButton
          label={t('STAKING_TERMINAL_REWARDS_ACTION')}
          variant="success"
          onClick={openClaimModal}
          fullWidth
        />
      </Container>

      {completedUser && (
        <ClaimModal
          personas={completedUser.user.personas.filter((p) =>
            tokenIds.includes(p.tokenId),
          )}
          open={isClaimModalOpen}
          onClose={closeClaimModal}
        />
      )}
    </>
  );
};
